import NavMenuItem from "../ui/nav-menu-item";
import { useState, useContext } from "react";
import SearchModal from "./search-modal";
import ActionIcon from "../ui/action-icon";
import { Search } from "lucide-react";
import UserContext from "../../contexts/user-context";
import BusinessContext from "../../contexts/business-context";
import Tooltips from "../ui/tooltip";
import NavSection from "./nav-section";
import { useRouter } from "next/router";

const MailMenuItems = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dropdownStates, setDropdownStates] = useState({
        workpegAI: false,
        dashboard: false,
    });
    const router = useRouter();
    const userCtx = useContext(UserContext);
    const user = userCtx.user;
    const businessCtx = useContext(BusinessContext);
    const business = businessCtx.activeBusiness;





    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const toggleDropdown = (dropdown) => {
        setDropdownStates((prevState) => ({
            ...prevState,
            [dropdown]: !prevState[dropdown],
        }));
    }
    if (router.pathname.includes("/inbox")) {
        return (
            <div className="grid gap-[4px] content-start max-h-[70dvh] overflow-y-scroll scrollbar-none">
                <NavMenuItem icon="inbox" href="/inbox">
                    Inbox
                </NavMenuItem>
                <NavMenuItem icon="star" href="/mail/starred">
                    Starred
                </NavMenuItem>
                <NavMenuItem history={() => { setHistory(true) }} icon="sparkles" href="/chats">
                    Workpeg AI
                </NavMenuItem>

                <NavSection >
                    <NavMenuItem icon="send-horizontal" href="/mail/sent">
                        Sent
                    </NavMenuItem>
                    <NavMenuItem icon="archive-restore" href="/mail/drafts">
                        Draft
                    </NavMenuItem>
                    <NavMenuItem icon="trash-2" href="/mail/trash">
                        Trash
                    </NavMenuItem>
                </NavSection>

                <NavSection>
                    <NavMenuItem icon="chart-bar-stacked" href="/mail/categories">
                        Categories
                    </NavMenuItem>
                    <NavMenuItem icon="timer" href="/mail/important">
                        Important
                    </NavMenuItem>
                    <NavMenuItem icon="star" href="/mail/trash">
                        Favorite
                    </NavMenuItem>
                </NavSection>

                {isModalOpen && <SearchModal toggleModal={toggleModal} />}
            </div>
        );
    }
    else {
        return null;
    }

};

export default MailMenuItems;
